import { Component, inject } from '@angular/core';
import { DownloadTaskService, DownloadTask } from '../../services/download-task.service';

@Component({
  selector: 'app-download-toast',
  standalone: true,
  imports: [],
  templateUrl: './download-toast.component.html',
  styleUrls: ['./download-toast.component.scss'],
})
export class DownloadToastComponent {
  protected readonly ts = inject(DownloadTaskService);

  toggleExpand(): void {
    this.ts.expanded.update(v => !v);
  }

  clearCompleted(e: Event): void {
    e.stopPropagation();
    this.ts.clearCompleted();
  }

  remove(requestId: string): void {
    this.ts.removeTask(requestId);
  }

  statusLabel(task: DownloadTask): string {
    switch (task.status) {
      case 'queued':      return 'Queued — building ZIP\u2026';
      case 'downloading': return 'Downloading file\u2026';
      case 'done':        return 'Saved to disk';
      case 'failed':      return task.reason || 'Generation failed';
    }
  }
}
